'use strict';
// write your code here
var allElement = document.querySelectorAll('.population');
var numbers = [];
allElement.forEach(function(el) {
    var text = el.textContent.replace(/[, ]+/g, '');
    var num = Number(text);
    if (Number.isFinite(num)) numbers.push(num);
});
var total = numbers.reduce(function(sum, el) {
    return sum + el;
}, 0);
var average = 0;
if (numbers.length > 0) average = Math.round(total / numbers.length);
var totalFormat = total.toLocaleString('en-US');
var averageFormat = average.toLocaleString('en-US');
var totalEl = document.querySelectorAll('.total-population');
totalEl.forEach(function(el) {
    el.textContent = totalFormat;
});
var averageEl = document.querySelectorAll('.average-population');
averageEl.forEach(function(el) {
    el.textContent = averageFormat;
});

//# sourceMappingURL=js_get_data_DOM.b559666e.js.map
